module.exports = __webpack_public_path__ + "static/media/arrow.3515d0a2.svg";